// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"291":"7de9cbc3","404":"315aca04","761":"e12e9ca7","787":"16d0fd8e","894":"d6d016e4","980":"5341f3cf"}[chunkId] + ".chunk.js";
};